const s = {
  name: "FaceId",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,7c0-2.8,2.2-5,5-5h5V0H7C3.1,0,0,3.1,0,7v5h2V7z"/>
		<path class="st0" d="M28,2h5c2.8,0,5,2.2,5,5v5h2V7c0-3.9-3.1-7-7-7h-5V2z"/>
		<path class="st0" d="M38,33v-5h2v5c0,3.9-3.1,7-7,7h-5v-2h5C35.8,38,38,35.8,38,33z"/>
		<path class="st0" d="M2,33v-5H0v5c0,3.9,3.1,7,7,7h5v-2H7C4.2,38,2,35.8,2,33z"/>
		<path class="st0" d="M12.9,27.1c1.8,1.8,4.3,2.9,7.1,2.9s5.3-1.1,7.1-2.9l1.4,1.4C26.3,30.7,23.3,32,20,32s-6.3-1.3-8.5-3.5
			L12.9,27.1z"/>
		<path class="st0" d="M11,16c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2h2c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4H11z"/>
		<path class="st0" d="M27,14c-1.1,0-2,0.9-2,2h-2c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4h-2C29,14.9,28.1,14,27,14z"/>
		<path class="st0" d="M19,16v5c0,2.8,2.2,5,5,5v-2c-1.7,0-3-1.3-3-3v-5H19z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as FaceId
};
